import { render, staticRenderFns } from "./TaskOverall.vue?vue&type=template&id=2f7b06d8"
import script from "./TaskOverall.vue?vue&type=script&lang=js"
export * from "./TaskOverall.vue?vue&type=script&lang=js"
import style0 from "./TaskOverall.vue?vue&type=style&index=0&id=2f7b06d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports